<template>
    <div class="settings-page__clear-cache clear-storage-wrapper">
        <clear-storage />
    </div>
</template>
